















































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import GameModule from '@/store/modules/Game';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class DemoUrl extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Game name',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Demo URL',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Manage',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ];

  GameInstance = getModule(GameModule, this.$store);

  data = [];

  version = false;

  statusMaintenance = '';

  url = '';

  prefix = '';

  created() {
    this.fetchGame();
  }

  async fetchGame() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.FetchGame();
    this.checkError(res);
    this.data = res;
    this.GeneralInstance.toggleLoading(false);
  }

  editDemoUrl(val) {
    this.prefix = val.prefix;
    this.url = val.fp_url;
    this.version = true;
  }

  async handleDemoUrl(val) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.EditDemoUrl({
      url: val,
      prefix: this.prefix,
    });
    if (res.code === 0) {
      this.checkError(res);
    } else {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    }
    this.version = false;
    this.fetchGame();
    this.GeneralInstance.toggleLoading(false);
  }

  handleChange() {
    this.fetchGame();
  }
}
